export default "<div class=\"text-center mt-5 pt-5\">\n  <span><i class=\"fa fa-spinner fa-4x fa-pulse\"></i></span>\n</div>"